module.exports = __webpack_public_path__ + "prod/1.42.2/img/h5_banner_bg.6d6c6654.png";